import { Bar } from './BaseCharts';

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      default() {
        return [];
      },
    },
    bgColor: {
      type: String,
      default() {
        return [];
      },
    },
    numData: {
      type: Array,
      default() {
        return [];
      },
    },
    tooltipsOpen: {
      type: Boolean,
      default: false,
    },
    tooltipsCompanyText: {
      type: Boolean,
      default: false,
    },
    labelAxesY: {
      type: Boolean,
      default: true,
    },
    maxY: {
      type: Number,
      default: 0,
    },
    timeout: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    const tooltipsCompanyText = this.tooltipsCompanyText;
    setTimeout(() => {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: this.bgColor,
              data: this.numData,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
            callbacks: {
              title(tooltipItems, data) {
                return '';
              },
              label(tooltipItem, data) {
                let label = data.labels[tooltipItem.datasetIndex] || '';
                const num = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                var numComma = 0;
                if (num > -1) {
                  var numComma = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                }

                const companyText =
									num > 1 && tooltipsCompanyText === true
									  ? 'companies'
									  : num <= 1 && tooltipsCompanyText === true
									    ? 'company'
									    : '';
                label = `${data.labels[tooltipItem.index]}: ${numComma} ${companyText}`;
                return label;
              },
            },
            enabled: this.tooltipsOpen,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                  color: this.bgColor,
                  lineWidth: 2,
                },
                barThickness: 20,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: 'rgba(0, 0, 0, 0.1)',
                  lineWidth: 1,
                },
                ticks: {
                  display: this.labelAxesY,
                  min: 0,
                  max: this.maxY,
                  precision: 0,
                },
              },
            ],
          },
          // animation: {
          //   duration: 500,
          //   onProgress() {
          //     const chartInstance = this.chart;
          //     const ctx = chartInstance.ctx;
          //     ctx.font = Chart.helpers.fontString(
          //       Chart.defaults.global.defaultFontSize,
          //       Chart.defaults.global.defaultFontStyle,
          //       Chart.defaults.global.defaultFontFamily,
          //     );
          //     ctx.fillStyle = this.chart.config.options.defaultFontColor;
          //     ctx.textAlign = 'left';
          //     ctx.textBaseline = 'bottom';

          //     this.data.datasets.forEach((dataset, i) => {
          //       for (var i = 0; i < dataset.data.length; i++) {
          //         if (dataset.data[i] != 0) {
          //           const model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
          //           const textY = model.y + (dataset.type == 'line' ? -3 : 15);

          //           ctx.font = Chart.helpers.fontString(
          //             Chart.defaults.global.defaultFontSize,
          //             'normal',
          //             Chart.defaults.global.defaultFontFamily,
          //           );
          //           ctx.textAlign = 'start';
          //           ctx.textBaseline = 'middle';
          //           ctx.fillStyle = dataset.type == 'line' ? 'black' : 'black';
          //           ctx.save();
          //           ctx.translate(model.x, textY - 16);
          //           ctx.rotate(4.7);
          //           ctx.fillText(dataset.data[i], 0, 0);
          //           ctx.restore();
          //         }
          //       }
          //     });
          //   },
          // },
        },
      );
    }, this.timeout * 1000);
  },
};
